import React from 'react';

const BankAccountInfo = ({ number, bank }) => {
  return (
    <>
      <p>Číslo účtu: {number}</p>
      <p>Banka: {bank}</p>
    </>
  );
};

export default BankAccountInfo; 